import Swal from "sweetalert2";
import 'animate.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import i18n from 'i18next';


const swalErrorAlert = (msg) => {
  return new Promise(resolve => {
    Swal.fire({
      title: i18n.t("Error!"),
      text: msg,
      icon: "error",
      width: 400,
      confirmButtonText: i18n.t("OK"),
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(true);
      }
      else {
        resolve(false);
      }
    })
  });
};

const swalSuccessAlert = (msg) => {
  return new Promise(resolve => {
    Swal.fire({
      title: i18n.t("Success!"),
      text: msg,
      icon: "success",
      width: 400,
      confirmButtonText: i18n.t("OK"),
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(true);
      }
      else {
        resolve(false);
      }
    })
  })
};

const swalConfirmGeneralAlert = (msg, options = {}) => {
  return new Promise(resolve => {
    const docs = (options.docSelection && Array.isArray(options.docSelection.docs))
      ? options.docSelection.docs
      : [];
    const globalDocs = options.docSelection && options.docSelection.globalDocs;
    const showGlobalUser = globalDocs && globalDocs.userManual;
    const showGlobalRules = globalDocs && globalDocs.rules;
    const useDocSelection = docs.length > 0 || showGlobalUser || showGlobalRules;
    let html = undefined;
    let didOpen = undefined;
    let preConfirm = undefined;

    if (useDocSelection) {
      const globalBlock = (showGlobalUser || showGlobalRules) ? `
          <div style="margin-bottom: 14px;">
            ${showGlobalUser ? `
            <label style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; padding: 6px 0;">
              <input type="checkbox" id="cbGlobalUserManual" style="cursor: pointer; width: 18px; height: 18px; margin-top: 2px; flex-shrink: 0;" />
              <span style="font-weight: 500; color: #212529;">${i18n.t('Send User Manual')}</span>
            </label>` : ''}
            ${showGlobalRules ? `
            <label style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; padding: 6px 0;">
              <input type="checkbox" id="cbGlobalRules" style="cursor: pointer; width: 18px; height: 18px; margin-top: 2px; flex-shrink: 0;" />
              <span style="font-weight: 500; color: #212529;">${i18n.t('Send Rules and Regulations')}</span>
            </label>` : ''}
          </div>` : '';

      const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
          const date = new Date(dateString);
          return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          });
        } catch (e) {
          return dateString;
        }
      };

      const escapeHtml = (s) => String(s ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

      const docsData = docs.map((d) => {
        const label =
          (d.documentData && d.documentData[0] && d.documentData[0].name) ||
          (d.documentData && d.documentData[0] && d.documentData[0].pic_name) ||
          d.name ||
          d.pic_name ||
          i18n.t('Document');
        const updatedAt = d.updated_at || d.created_at || '';
        const id = d._id != null ? String(d._id) : '';
        return {
          id,
          label,
          formattedDate: formatDate(updatedAt)
        };
      }).filter((d) => d.id);

      const customerDocsBlock = docs.length > 0 ? `
          <div style="margin-bottom: 12px;">
            <label id="attachDocsMasterLabel" style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; padding: 0;">
              <input type="checkbox" id="attachDocsCheckbox" style="cursor: pointer; width: 18px; height: 18px; margin-top: 2px; flex-shrink: 0;" />
              <span style="font-weight: 500; color: #495057;">${i18n.t('Additional customer document')}</span>
            </label>
          </div>
          <div id="docMultiSelectContainer" style="display: none; padding: 12px; background-color: #f8f9fa; border-radius: 8px; border: 1px solid #e9ecef;">
            <div style="font-weight: 500; color: #495057; font-size: 14px; margin-bottom: 10px;">${i18n.t('Select one or more documents')}</div>
            <div id="docMultiSelectScroll" style="max-height: 160px; overflow-y: auto; overflow-x: hidden; padding-right: 6px;">
            ${docsData.map((doc) => `
              <label style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; padding: 8px 6px; border-radius: 6px; margin-bottom: 4px; border-bottom: 1px solid #e9ecef;">
                <input type="checkbox" class="credential-doc-cb" value="${escapeHtml(doc.id)}" style="cursor: pointer; width: 16px; height: 16px; margin-top: 3px; flex-shrink: 0;" />
                <span style="flex: 1;">
                  <span style="display: block; font-weight: 500; color: #212529; font-size: 14px;">${escapeHtml(doc.label)}</span>
                  <span style="display: block; font-size: 12px; color: #6c757d;">${escapeHtml(doc.formattedDate || i18n.t('No date available'))}</span>
                </span>
              </label>
            `).join('')}
            </div>
          </div>` : '';

      html = `
        <div style="text-align: left; padding: 8px 0;">
          ${globalBlock}
          ${customerDocsBlock}
        </div>
      `;

      didOpen = () => {
        const popup = Swal.getPopup();
        if (popup) {
          popup.style.margin = 'auto';
          popup.style.overflow = 'visible';
        }
        const htmlHost = Swal.getHtmlContainer();
        if (htmlHost) {
          htmlHost.style.maxHeight = 'none';
          htmlHost.style.overflow = 'visible';
        }
        const actions = Swal.getActions();
        if (actions) {
          actions.style.marginTop = '0.5rem';
        }
        if (!document.getElementById('swal-credential-doc-fix-styles')) {
          const style = document.createElement('style');
          style.id = 'swal-credential-doc-fix-styles';
          style.textContent = `
            .swal2-popup.swal-credential-doc-popup {
              overflow: visible !important;
              padding-bottom: 1.5rem !important;
            }
            .swal2-html-container.swal-credential-doc-html {
              overflow: visible !important;
              max-height: none !important;
            }
          `;
          document.head.appendChild(style);
        }
        const master = popup && popup.querySelector('#attachDocsCheckbox');
        const container = popup && popup.querySelector('#docMultiSelectContainer');
        const masterLabel = popup && popup.querySelector('#attachDocsMasterLabel');
        if (master && container) {
          master.addEventListener('change', () => {
            container.style.display = master.checked ? 'block' : 'none';
            if (!master.checked) {
              popup.querySelectorAll('.credential-doc-cb').forEach((el) => { el.checked = false; });
            }
          });
        }
      };

      preConfirm = () => {
        const popup = Swal.getPopup();
        const cbUm = popup.querySelector('#cbGlobalUserManual');
        const cbRr = popup.querySelector('#cbGlobalRules');
        const includeUserManual = cbUm ? cbUm.checked : false;
        const includeRules = cbRr ? cbRr.checked : false;
        const master = popup.querySelector('#attachDocsCheckbox');
        if (!master || !master.checked) {
          return { docIds: [], includeUserManual, includeRules };
        }
        const checkedBoxes = Array.from(popup.querySelectorAll('.credential-doc-cb:checked'));
        if (checkedBoxes.length === 0) {
          Swal.showValidationMessage(i18n.t('Please select at least one document'));
          return false;
        }
        return { docIds: checkedBoxes.map((c) => c.value), includeUserManual, includeRules };
      };
    }

    Swal.fire({
      title: i18n.t('Confirm!!!'),
      text: useDocSelection ? undefined : msg,
      html: useDocSelection ? `<p style="margin-bottom:12px;">${msg}</p>${html}` : undefined,
      icon: "warning",
      width: 'min(560px, 94vw)',
      padding: '1.25em',
      customClass: {
        icon: 'no-border',
        popup: 'swal-credential-doc-popup',
        htmlContainer: 'swal-credential-doc-html'
      },
      showCancelButton: true,
      confirmButtonColor: '#d92550',
      cancelButtonColor: 'grey',
      cancelButtonText: i18n.t('Cancel'),
      confirmButtonText: i18n.t('Yes, Do it!'),
      didOpen,
      preConfirm: useDocSelection ? preConfirm : undefined
    }).then((result) => {
      if (result.isConfirmed) {
        if (useDocSelection) {
          const docIds = (result.value && Array.isArray(result.value.docIds)) ? result.value.docIds : [];
          const includeUserManual = result.value && result.value.includeUserManual;
          const includeRules = result.value && result.value.includeRules;
          resolve({
            confirmed: true,
            docIds,
            includeUserManual: !!includeUserManual,
            includeRules: !!includeRules,
          });
        } else {
          resolve(true);
        }
      }
      else {
        if (useDocSelection) {
          resolve({
            confirmed: false,
            docIds: [],
            includeUserManual: false,
            includeRules: false,
          });
        } else {
          resolve(false);
        }
      }
    })
  })
};

const swalConfirmDeleteAlert = msg => {
  return new Promise(resolve => {
    Swal.fire({
      title: i18n.t('Are you sure?'),
      text: msg,
      iconHtml: '<img src="../custom/trash.png" width=100px, height=100px>',
      customClass: {
        icon: 'no-border'
      },
      showCancelButton: true,
      confirmButtonColor: '#d92550',
      cancelButtonColor: 'grey',
      cancelButtonText: i18n.t('Cancel'),
      confirmButtonText: i18n.t('Yes, delete it!')
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(true);
      }
      else {
        resolve(false);
      }
    })
  })
};

const successToast = (msg) => {
  toast.success(msg,
    {
      position: toast.POSITION.TOP_RIGHT,
      theme: "light",
    });
};



const AlertService = {
  swalErrorAlert,
  swalSuccessAlert,
  swalConfirmGeneralAlert,
  swalConfirmDeleteAlert,
  successToast
};
export default AlertService;

